import { render, staticRenderFns } from "./Workplace.vue?vue&type=template&id=8f2fe2dc&scoped=true"
import script from "./Workplace.vue?vue&type=script&lang=js"
export * from "./Workplace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2fe2dc",
  null
  
)

export default component.exports